import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";
import {MaCantineConnectionDTO} from "../../dtos/egalim/ma-cantine-connection-dto";
import {HttpService} from "../technique/http.service";
import {Auth2Service} from "../security/auth2.service";
import {catchError} from "rxjs/operators";
import {UtilsService} from "../../utils/utils.service";
import {StatistiqueEgalimDTO} from "../../dtos/egalim/statistique-egalim-dto";
import { HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class StatistiquesEGAlimService {

  private subjectOpenCreationDialog = new Subject<boolean>();
  openCreationDialog$ = this.subjectOpenCreationDialog.asObservable();

  private subjectOpenErrorDialog = new Subject<any>();
  openErrorDialog$ = this.subjectOpenErrorDialog.asObservable();

  private subjectOpenMaCantineConnectionDialog = new Subject<MaCantineConnectionDTO>();
  openMaCantineConnectionDialog$ = this.subjectOpenMaCantineConnectionDialog.asObservable();

  private subjectOnMaCantineCredentialsUpdate = new Subject<MaCantineConnectionDTO>();
  onMaCantineCredentialsUpdate$ = this.subjectOnMaCantineCredentialsUpdate.asObservable();

  private subjectOnStatistiqueEGAlimGenerated = new Subject<StatistiqueEgalimDTO>();
  onStatistiqueEGAlimGenerated$ = this.subjectOnStatistiqueEGAlimGenerated.asObservable();

  private subjectOpenStatistiquesEGAlimDetailsDialog = new Subject<number>();
  onOpenStatistiquesEGAlimDetailsDialog$ = this.subjectOpenStatistiquesEGAlimDetailsDialog.asObservable();

  private subjectOpenStatistiquesEGAlimConformiteDialog = new Subject<StatistiqueEgalimDTO>();
  onOpenStatistiquesEGAlimConformiteDialog$ = this.subjectOpenStatistiquesEGAlimConformiteDialog.asObservable();

  constructor(private httpSvc: HttpService,
              private utilsSvc: UtilsService,
              private auth2Svc: Auth2Service) {
  }

  public openCreationDialog = () => {
    this.subjectOpenCreationDialog.next(true);
  }

  public openErrorDialog = (errors) => {
    this.subjectOpenErrorDialog.next(errors);
  }

  public openMaCantineConnectionDialog = (maCantineConnection: MaCantineConnectionDTO) => {
    this.subjectOpenMaCantineConnectionDialog.next(maCantineConnection);
  }

  public onMaCantineCredentialsUpdate = (maCantineConnection: MaCantineConnectionDTO) => {
    this.subjectOnMaCantineCredentialsUpdate.next(maCantineConnection);
  }

  saveMaCantineCredentials(clientId: string, clientSecret: string) {
    let url = 'dolrest/ma-cantine/save'
    let body = {
      clientId: clientId,
      clientSecret: clientSecret
    }

    return this.httpSvc.post(url, body);
  }

  getMaCantineConnection() {
    return this.httpSvc.get("dolrest/ma-cantine/connexion");
  }

  initiateMaCantineConnection() {
    this.httpSvc.get(`dolrest/start-oauth2/MaCantine_${this.auth2Svc.utilisateur.username}`).pipe(
      catchError(error => this.utilsSvc.handleError(error, true))
    ).subscribe(response => {
      window.location.href = response.one;
    });
  }

  generate(siteId: number, year: number, pointTeledeclarationIds: number[]): Observable<any> {
    return this.httpSvc.post(`dolrest/statistiques-egalim/generate`, {
      siteId,
      year,
      pointTeledeclarationIds
    })
  }

  onStatistiqueEGAlimGenerated(statistique: StatistiqueEgalimDTO) {
    this.subjectOnStatistiqueEGAlimGenerated.next(statistique);
  }

  openDetailsDialog(id: number) {
    this.subjectOpenStatistiquesEGAlimDetailsDialog.next(id);
  }

  openConformiteDialog(stat: StatistiqueEgalimDTO) {
    this.subjectOpenStatistiquesEGAlimConformiteDialog.next(stat);
  }

  export(ids: number[]) {
    let params = new HttpParams().set("ids", ids.join(','));
    console.log("Ids :", params);
    return this.httpSvc.get(`dolrest/statistiques-egalim/export`, params, 'blob');
  }

  teledeclare(ids: number[]) {
    return this.httpSvc.post(`dolrest/ma-cantine/teledeclaration`, ids);
  }

  sendByEmail(ids: number[]) {
    return this.httpSvc.post(`dolrest/statistiques-egalim/send`, ids);
  }

  getConformite(statistiqueId: number, seuilBio: number, seuilDurable: number, seuilViandePoisson: number): Observable<any> {
    let params: HttpParams = new HttpParams()
      .set("statistiqueId", statistiqueId)
      .set("egalimThresholdBio", seuilBio)
      .set("egalimThresholdSustainableProducts", seuilDurable)
      .set("egalimThresholdPoissonViandeDurable", seuilViandePoisson);

    return this.httpSvc.get(`dolrest/statistiques-egalim/calcul-conformite`, params);
  }
}
